module.exports = __webpack_public_path__ + "img/53.85f22f8e.jpg";